"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateEnvironment = exports.environmentSchema = void 0;
var zod = _interopRequireWildcard(require("zod"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const validEnvironments = ['uat', 'stg', 'live'];
const environmentSchema = exports.environmentSchema = zod.enum(validEnvironments).or(zod.string()).refine(val => validEnvironments.includes(val.toLowerCase()), {
  message: `Environment must be one of: ${validEnvironments.join(', ')} (case-insensitive)`
}).transform(val => val.toLowerCase());

/**
 * Validates the provided environment against the environment schema.
 *
 * @param environment - The environment string to validate. It can be undefined.
 * @returns The lowercased validated environment data if the validation is successful, otherwise undefined.
 */
const validateEnvironment = environment => {
  if (!environment) {
    return undefined;
  }
  const result = environmentSchema.safeParse(environment);
  if (result.success) {
    return result.data;
  }
  return undefined;
};
exports.validateEnvironment = validateEnvironment;
//# sourceMappingURL=validateEnvironment.js.map